import React from 'react'

function LoadingSpinner2() {
  return (
    <div>
        <div class="lds-ellipsis p-0 object-contain">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
  )
}

export default LoadingSpinner2